"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
const ApiClient_1 = require("../lib/ApiClient");
exports.isFollowingsNotificationDetails = (details) => {
    var _a;
    return ((_a = details) === null || _a === void 0 ? void 0 : _a[ApiClient_1.typenameSymbol]) === "FollowingsNotificationDetails";
};
class FollowingsProvider extends DataProvider_1.default {
    get fragments() {
        return {
            Follower: () => `
        ... on Follower {
          userId
          user {
            ${this.getFragment("UserPublicData")}
          }          
          followerId
          follower {
            ${this.getFragment("UserPublicData")}
          }
          time
        }`,
            NotificationDetails: () => `
        ... on FollowingsNotificationDetails {
          empty
        }
      `,
            FollowingStatistic: () => `
        ... on FollowingStatistic {
          userId
          followerCount
          followingCount
        }
      `,
        };
    }
    searchFollowings({ ids }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("followingsSearchFollowings", { ids }, this.getFragment("Follower"));
        });
    }
    find({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("followingsFind", { data }, this.getPageableFragment("Follower"));
        });
    }
    toggle({ id }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("followingsToggle", { id });
        });
    }
    getStatistic({ ids }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("followingsStatistic", { ids }, this.getFragment("FollowingStatistic"));
        });
    }
}
exports.FollowingsProvider = FollowingsProvider;
//# sourceMappingURL=FollowingsProvider.js.map